import { render, staticRenderFns } from "./tasks-list.vue?vue&type=template&id=6d3f2b2d&"
import script from "./tasks-list.vue?vue&type=script&lang=ts&"
export * from "./tasks-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports